import times from 'lodash.times';
import { useCallback } from 'react';
import { PaginationStep } from "./PaginationStep";
import { PaginationRoot } from "./styles";
import { isNextSlide, isPaginationStepHidden, isPreviousSlide } from "./utils";
import { jsx as _jsx } from "react/jsx-runtime";
export var Pagination = function Pagination(_ref) {
  var autoplay = _ref.autoplay,
    currentSlide = _ref.currentSlide,
    instanceRef = _ref.instanceRef,
    isMobile = _ref.isMobile,
    pagination = _ref.pagination,
    slidesCount = _ref.slidesCount;
  var onPaginationStepClick = useCallback(function (slideIndex) {
    var _instanceRef$current;
    return (_instanceRef$current = instanceRef.current) === null || _instanceRef$current === void 0 ? void 0 : _instanceRef$current.moveToIdx(slideIndex);
  }, [instanceRef]);
  if (slidesCount < 2 || currentSlide < 0 || currentSlide >= slidesCount) {
    return null;
  }
  return /*#__PURE__*/_jsx(PaginationRoot, {
    children: times(slidesCount).map(function (_, slideIndex) {
      return /*#__PURE__*/_jsx(PaginationStep
      // eslint-disable-next-line react/no-array-index-key -- No other option for passing data to key
      , {
        autoplay: autoplay,
        hidden: isPaginationStepHidden({
          currentSlide: currentSlide,
          slidesCount: slidesCount,
          slideIndex: slideIndex
        }),
        isActive: slideIndex === currentSlide,
        isNext: isNextSlide({
          slidesCount: slidesCount,
          currentSlide: currentSlide,
          slideIndex: slideIndex
        }),
        isPrevious: isPreviousSlide({
          slidesCount: slidesCount,
          currentSlide: currentSlide,
          slideIndex: slideIndex
        }),
        pagination: pagination,
        slideIndex: slideIndex,
        onPaginationStepClick: slideIndex === currentSlide || isMobile ? undefined : onPaginationStepClick
      }, slideIndex);
    })
  });
};
//# sourceMappingURL=Pagination.js.map